import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartAccModel, JournalSearchChartAccModel } from 'src/app/models/Accounting/tChartAccModel';
import { tChartAccModel } from 'src/app/models/tChartAccModel';
import { ChartAccService } from 'src/app/services/Accounting/ChartAcc.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-search-chart-account-dialog',
  templateUrl: './search-chart-account-dialog.component.html',
  styleUrls: ['./search-chart-account-dialog.component.css']
})
export class SearchChartAccountDialogComponent implements OnInit {

  TAG = "SearchChartAccountDialogComponent";

  editForm: FormGroup;

  @Input() vouDate: number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  dataSource: MatTableDataSource<JournalSearchChartAccModel>;
  checkLoadingDataSource: any;
  dataList: JournalSearchChartAccModel[];

  //loading spinner
  isLoading = true;

  displayedColumns: string[] = [
    'groupType',
    'accCode',
    'currCode',
    'accName',
    'accNameFC',

  ];
  accFilter = new FormControl();

  filteredValues = {
    accType:'',accCode: '', accName: '',currCode:'',accNameFC:''
  };


  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private chartAccService: ChartAccService
   // private dateTimeConvertService: DateTimeConvertService,
  ) { }

  ngOnInit() {
    this.getAllData();
  }


  getAllData(): void {
    this.log.i(this.TAG, 'do getAllData this.vouDate = '+this.vouDate);
    
    const value = {
      vouDate: this.vouDate
    };

    this.chartAccService.journalSearchChart(value).subscribe(data => {

      this.dataList = data;

      this.dataSource = new MatTableDataSource<JournalSearchChartAccModel>(this.dataList);
      this.dataSource.paginator = this.paginator;

      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;
      //table sort
      this.dataSource.sort = this.sort;

      this.accFilter.valueChanges.subscribe((value) => {
        this.filteredValues['accType']=value;
        this.filteredValues['accCode'] = value;
        this.filteredValues['accName'] = value;
        this.filteredValues['currCode']=value;
        this.filteredValues['accNameFC']=value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();

    },
      error => this.isLoading = false);
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: JournalSearchChartAccModel, filter: string): boolean => {

      const searchString = JSON.parse(filter);

      return ((searchString.accCode.toLowerCase() === '' ||
      (data.accCode != null && data.accCode.toString().trim().toLowerCase().indexOf(searchString.accCode.toLowerCase()) !== -1))
      ||
      (searchString.accName.toLowerCase() === '' ||
        (data.accName != null && data.accName.toString().trim().toLowerCase().indexOf(searchString.accName.toLowerCase()) !== -1))
      ||
      (searchString.accType.toLowerCase() === '' ||
        (data.accType != null && data.accType.toString().trim().toLowerCase().indexOf(searchString.accType.toLowerCase()) !== -1))
      ||
      (searchString.currCode.toLowerCase() === '' ||
        (data.currCode != null && data.currCode.toString().trim().toLowerCase().indexOf(searchString.currCode.toLowerCase()) !== -1))
      ||
      (searchString.accNameFC.toLowerCase() === '' ||
        (data.accNameFC != null && data.accNameFC.toString().trim().toLowerCase().indexOf(searchString.accNameFC.toLowerCase()) !== -1))    
    );
      
    };
    return myFilterPredicate;
  }
  selectedRecord(selectedModel: JournalSearchChartAccModel) {
    this.log.i(this.TAG, "selectedRecord data = " + selectedModel.accName);


    this.activeModal.close(selectedModel);

  }
}
